<vi-icon-button
  data-at-button
  (click)="openOverlay()"
  gtm="onGoToPage"
  gtmAction="Open Service Ticket Overlay"
  gtmCategory="Service Ticket"
>
  headset_mic
</vi-icon-button>
